// extracted by mini-css-extract-plugin
export default {"container":"TempSettingsPage_container__5HVIV","title":"TempSettingsPage_title__trow2","nav":"TempSettingsPage_nav__rejww"};